import { useEffect } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export function applyAppearance(a) {
  if (!a) return;
  document.documentElement.style.setProperty("--app-font", a.font_family);
  let link = document.getElementById("app-font-link");
  if (a.css_url) {
    if (!link) { link = document.createElement("link"); link.id = "app-font-link"; link.rel = "stylesheet"; document.head.appendChild(link); }
    if (link.href !== a.css_url) link.href = a.css_url;
  } else if (link) link.remove();
  let style = document.getElementById("app-font-custom");
  if (a.heartstrings_font_data) {
    if (!style) { style = document.createElement("style"); style.id = "app-font-custom"; document.head.appendChild(style); }
    style.textContent = `@font-face{font-family:'Heartstrings';src:url(${a.heartstrings_font_data});font-display:swap;}`;
  } else if (style) style.remove();
}

export default function AppearanceLoader() {
  useEffect(() => { axios.get(`${API}/appearance`).then((r) => applyAppearance(r.data)).catch(() => {}); }, []);
  return null;
}
